import React, { FC, memo } from 'react';
import { FlexRow } from '@minecraft.atoms';
import Button from '@minecraft.button';
import { useTranslation } from '@blocs.i18n';
import {
  FilterBasicButtonContainer,
  FilterBasicButtonLabel,
  FilterIcon,
  ArrowIcon,
  HintText,
  StyledFiltersAplliedIndicator,
} from './FilterBasicButtonStyles';

type Props = {
  areFiltersApplied?: boolean;
  isFiltersFormDirty: boolean;
  toggleFilterBasicOverlay: () => void;
};

const FilterBasicButton: FC<Props> = ({ areFiltersApplied, isFiltersFormDirty, toggleFilterBasicOverlay }) => {
  const { t } = useTranslation();

  return (
    <FilterBasicButtonContainer>
      <Button isTall mobileBlock noPadding onClick={toggleFilterBasicOverlay}>
        <FlexRow alignItems="center" justifyContent="space-between" className="cn_mx-4">
          <FilterIcon name="filter" alt={t('common:button.filter')} inheritColor />
          <FilterBasicButtonLabel>{t('common:button.filter')}</FilterBasicButtonLabel>
          <ArrowIcon name="caret-1" inheritColor />
        </FlexRow>
      </Button>
      {areFiltersApplied && <StyledFiltersAplliedIndicator />}
      {isFiltersFormDirty && <HintText>{t('common:filter.hintText')}</HintText>}
    </FilterBasicButtonContainer>
  );
};

export default memo(FilterBasicButton);
